import Store from './store'

const lsStore = Store({
    expandedTab: null,
}, 'dashboard_state_persistance')

export function setExpandedTab(value = false) {
    lsStore.commit('save', {
        key: 'expandedTab',
        value: value
    })
}

export function getExpandedTab() {
    return lsStore.state.expandedTab
}
